var avatarUrlMixin = {
  methods: {
    getAvatarUrl (event, name, bool) {
      function hashCode (str) { // java String#hashCode
        var hash = 0
        if (str?.length) {
          for (var i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash)
          }
        }
        return hash
      }

      function intToHex (i) {
        var c = (i & 0x00FFFFFF)
          .toString(16)
          .toUpperCase()

        return '00000'.substring(0, 6 - c.length) + c
      }
      const src = 'https://avatar.oxro.io/avatar?name=' + name?.toUpperCase().split(' ').join('+') + '&background=3ACA56' + '&color=212338' + '&bold=true'

      if (bool) {
        return src
      } else {
        event.target.src = src
      }
    }
  }
}

export default avatarUrlMixin
